export default "__VITE_ASSET__2cd847fe__"